import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   hoy: new Date()
};

const constantes = createSlice({
   name: 'constantes',
   initialState: initialState,
   reducers: {}
});

const constantesReducer = constantes.reducer;
export default constantesReducer;
